import 'ckeditor'

console.log('Hello World from Webpacker ckeditor pack')